import { memo, useCallback } from "react";

import { TextField } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";

import type { DateTime } from "luxon";

type DatePickerComponentProps = {
  open: boolean;
  value: DateTime;
  onOpen: () => void;
  onClose: () => void;
  onAccept: (value: Date | null) => void;
  onClick: () => void;
};

const DatePickerComponent = memo((props: DatePickerComponentProps) => {
  const { open, value, onOpen, onClose, onAccept, onClick } = props;

  return (
    <DatePicker
      openTo="year"
      open={open}
      format="d MMM yyyy"
      disableFuture={true}
      value={value.toJSDate()}
      onOpen={onOpen}
      onClose={onClose}
      onAccept={onAccept}
      onChange={useCallback(() => {
        // eslint-disable-line @typescript-eslint/no-empty-function
      }, [])}
      slots={{
        textField: (params) => (
          <TextField
            {...params}
            onClick={onClick}
            inputProps={{ ...params.inputProps, readOnly: true, tabIndex: -1 }}
          />
        ),
      }}
    />
  );
});

export default DatePickerComponent;
